import { useEffect } from "react";
import { TinkoffPayment, TinkoffPaymentStatus, TOrder } from "@core/types";
import { queryClient } from "../../../config/query-client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import useGetTinkoffPaymentQuery from "./useGetTinkoffPaymentQuery";

const useGetTinkoffPaymentStatus = (
  paymentId: TinkoffPayment["providerPaymentId"] | undefined,
  paymentStatus: TinkoffPaymentStatus | undefined,
  orderId: TOrder["id"],
  setPaymentStatus: (status: TinkoffPaymentStatus | undefined) => void,
  setIsPaymentLoading: (isLoading: boolean) => void,
) => {
  const { t } = useTranslation();
  const getPaymentQuery = useGetTinkoffPaymentQuery({
    orderId: orderId,
    options: {
      enabled: !!paymentId && paymentStatus === "NEW",
      refetchInterval: 3000,
    },
  });

  const invalidateOrderAndCards = async () => {
    setPaymentStatus("CONFIRMED");
    setIsPaymentLoading(false);
    toast.success(t("Payment successful"));
    await queryClient.invalidateQueries(["order", orderId]);
  };

  const fetchedPaymentStatus = getPaymentQuery.data?.status as TinkoffPaymentStatus;

  useEffect(() => {
    if (fetchedPaymentStatus === "CONFIRMED") {
      invalidateOrderAndCards();
    }
  }, [fetchedPaymentStatus]);
};

export default useGetTinkoffPaymentStatus;
